import React, { Dispatch, useCallback, useState } from "react";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";

import DefaultModal from "../default-modal/default-modal.component";
import stylesForm from "../../assets/styles/form.module.scss";

import styles from "./chat-folder.module.scss";
import { ChatFolderModalState } from "./chat-folder.types";

import { ApplicationStore } from "~/app/application.store";
import { setChatFolderModalIsOpen } from "~/app/modals/modals.actions";
import { createChatFoldersAction } from "~/app/chat/folders/folders.actions";

const ChatFolderModalComponent: React.FC = () => {
  const dispatch: Dispatch<any> = useDispatch();

  const chatFolderModalIsOpen: boolean = useSelector(
    (state: ApplicationStore) => state.modals.setChatFolderModalIsOpen
  );

  const [chatFolderData, setChatFolderData]: [
    ChatFolderModalState,
    React.Dispatch<React.SetStateAction<ChatFolderModalState>>
  ] = useState<ChatFolderModalState>({
    title: "",
    position: 0,
    isGeneral: true
  });

  const handleChatFolderModalIsOpen: (isOpen: boolean) => void = useCallback(
    (isOpen: boolean): void => {
      dispatch(setChatFolderModalIsOpen(isOpen));
    },
    [dispatch]
  );
  const handleCreateChatFolderCallback: (newChatFolderData: ChatFolderModalState) => void = useCallback(
    (newChatFolderData: ChatFolderModalState) => {
      dispatch(createChatFoldersAction(newChatFolderData));
    },
    [dispatch]
  );

  const handleChange: (target: { name: string; value: string; type: string }) => void = (target: {
    name: string;
    value: string;
    type: string;
  }): void => {
    if (target.type === "radio" && target.name === "folderState") {
      if (target.value == "isGeneral") {
        setChatFolderData({ ...chatFolderData, isGeneral: true, isPrivate: false });
      } else {
        setChatFolderData({ ...chatFolderData, isGeneral: false, isPrivate: true });
      }
    } else {
      setChatFolderData({ ...chatFolderData, [target.name]: target.value });
    }
  };

  const handleCreateChatFolder: () => void = (): void => {
    if (chatFolderData.title !== "") {
      handleCreateChatFolderCallback(chatFolderData);
    }
  };

  return (
    <DefaultModal
      title="New Folder"
      modalState={chatFolderModalIsOpen}
      setModalState={handleChatFolderModalIsOpen}
      action={handleCreateChatFolder}
    >
      <div className={styles.row}>
        <div className={classNames(stylesForm.inputGroup, styles.colMd8)}>
          <input
            name="title"
            onChange={(e): void => handleChange(e.target)}
            placeholder="Title"
            value={chatFolderData.title}
          />
        </div>
        <div className={classNames(stylesForm.inputGroup, styles.colMd4)}>
          <input name="position" type="number" onChange={(e): void => handleChange(e.target)} placeholder="Position" />
        </div>
      </div>
      <div className={stylesForm.inputGroup}>
        <label className={stylesForm.radioWrapper}>
          <input
            type="radio"
            name="folderState"
            value="isGeneral"
            checked={chatFolderData.isGeneral ?? false}
            onChange={(e): void => handleChange(e.target)}
          />
          <span>Folder General</span>
        </label>
        <label className={stylesForm.radioWrapper}>
          <input
            type="radio"
            name="folderState"
            value="isPrivate"
            checked={chatFolderData.isPrivate ?? false}
            onChange={(e): void => handleChange(e.target)}
          />
          <span>Folder Private</span>
        </label>
      </div>
    </DefaultModal>
  );
};

export default ChatFolderModalComponent;
